import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';
import { Card, CardContent } from '../components/ui/card';
import { faqs, contactInfo } from '../data/mock';
import { Link } from 'react-router-dom';

const FAQ = () => {
  return (
    <div className="faq-page">
      {/* Hero */}
      <section className="bg-gradient-to-br from-blue-50 via-white to-blue-50 py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl font-bold text-gray-900 mb-6">Frequently Asked Questions</h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              Find answers to common questions about palliative care, our services, and how we can help
            </p>
          </div>
        </div>
      </section>

      {/* FAQs */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <Accordion type="single" collapsible className="space-y-4">
              {faqs.map((faq) => (
                <AccordionItem 
                  key={faq.id} 
                  value={`item-${faq.id}`}
                  className="bg-gradient-to-br from-white to-blue-50 border border-blue-200 rounded-2xl px-6 shadow-sm hover:shadow-md transition-all"
                >
                  <AccordionTrigger className="text-left text-lg font-semibold text-gray-900 hover:text-blue-600 transition-colors py-6">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-gray-600 leading-relaxed pb-6">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </section>

      {/* Still Have Questions */}
      <section className="py-20 bg-gradient-to-br from-blue-50 to-white">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto">
            <Card className="bg-gradient-to-r from-blue-600 to-blue-500 text-white border-none shadow-2xl">
              <CardContent className="p-12 text-center">
                <h2 className="text-3xl font-bold mb-4">Still Have Questions?</h2>
                <p className="text-lg text-blue-50 mb-8">
                  We're here to help. Reach out to our team for personalized answers and guidance.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <Link to="/contact">
                    <button className="bg-white text-blue-600 hover:bg-blue-50 px-8 py-4 rounded-full font-medium shadow-lg transition-all">
                      Contact Us
                    </button>
                  </Link>
                  <a href={`tel:${contactInfo.phone}`}>
                    <button className="border-2 border-white text-white hover:bg-white/10 px-8 py-4 rounded-full font-medium transition-all">
                      Call: {contactInfo.phone}
                    </button>
                  </a>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Resources */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">Additional Resources</h2>
              <p className="text-lg text-gray-600">
                Learn more about palliative care and how to support your loved ones
              </p>
            </div>
            
            <div className="grid md:grid-cols-3 gap-6">
              {[
                { title: "Understanding Pain Management", desc: "Learn about modern approaches to managing chronic pain" },
                { title: "Caregiver Support Guide", desc: "Essential tips for family members caring for loved ones" },
                { title: "End-of-Life Planning", desc: "Navigate difficult conversations with compassion" }
              ].map((resource, index) => (
                <Card key={index} className="border-l-4 border-l-blue-600 shadow-md hover:shadow-lg transition-all">
                  <CardContent className="p-6">
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">{resource.title}</h3>
                    <p className="text-gray-600 text-sm mb-4">{resource.desc}</p>
                    <a href={`tel:${contactInfo.phone}`} className="text-blue-600 hover:text-blue-700 font-medium text-sm">
                      Request Information →
                    </a>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQ;
